export const data = [
  {
    name: 'January',
    uv: 4000,
    pv: 2400,
    amt: 2400,
    value: 400
  },
  {
    name: 'February',
    uv: 3000,
    pv: 1398,
    amt: 2210,
    value: 300
  },
  {
    name: 'March',
    uv: 2000,
    pv: 9800,
    amt: 2290,
    value: 200
  },
  {
    name: 'April',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'May',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    name: 'June',
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    name: 'July',
    uv: 3490,
    pv: 4300,
    amt: 2100,
  },
  {
    name: 'August',
    uv: 4000,
    pv: 2400,
    amt: 2400
  },
  {
    name: 'September',
    uv: 3000,
    pv: 1398,
    amt: 2210
  },
  {
    name: 'October',
    uv: 2000,
    pv: 9800,
    amt: 2290
  },
  {
    name: 'November',
    uv: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    name: 'December',
    uv: 1890,
    pv: 4800,
    amt: 2181,
  }
];

export const pieData = [
  { name: 'Group A', value: 400 },
  { name: 'Group B', value: 300 },
  { name: 'Group C', value: 300 },
  { name: 'Group D', value: 200 },
];
